export default "__VITE_PUBLIC_ASSET__9724795f__"